import { httpService } from "@/services/http.service";
import { Pagination } from "@/models/pagination";
import Page, { DCC, LCC } from "@/models/page";

const state = {
  list: Pagination.prototype.createEmpty(),
  dccList: Pagination.prototype.createEmpty(),
  lccList: Pagination.prototype.createEmpty(),
};

const actions = {
  create: async ({ dispatch }, data) => {
    const response = await httpService.post("page", data);
    dispatch("getAll");
    return response.data.message;
  },
  getAll: async ({ commit }, options) => {
    const response = await httpService.get("page", { params: options });
    commit("SET_PAGES", response.data.data);
  },
  getEvery: async () => {
    const response = await httpService.get("page", { params: { limit: 100 } });
    return response.data.data.result.map((page) => new Page(page));
  },
  get: async (context, id) => {
    const response = await httpService.get(`page/${id}`);
    return new Page(response.data.data);
  },
  update: async ({ dispatch }, data) => {
    const response = await httpService.patch(`page/${data.get("id")}`, data);
    dispatch("getAll");
    return response.data.message;
  },
  delete: async ({ dispatch }, id) => {
    const response = await httpService.delete(`page/${id}`);
    dispatch("getAll");
    return response.data.message;
  },
  getAllDCC: async ({ commit }, options) => {
    const response = await httpService.get("dcc", { params: options });
    commit("SET_DCC_LIST", response.data.data);
  },
  getAllLCC: async ({ commit }, { dccId, options }) => {
    const response = await httpService.get(`dcc/${dccId}/lcc`, {
      params: options,
    });
    commit("SET_LCC_LIST", response.data.data);
  },
  createSubscription: async (context, { pageId, data }) => {
    const response = await httpService.post(
      `page/${pageId}/subscription`,
      data ?? {}
    );
    return response.data;
  },
  getSubscription: async (context, pageId) => {
    const response = await httpService.get(`page/${pageId}/subscription`);
    return response.data.data;
  },
  cancelSubscription: async (context, pageId) => {
    const response = await httpService.delete(
      `page/${pageId}/subscription`
    );
    return response.data.message;
  },
  getSubscriptionStatus: async (context, pageId) => {
    const response = await httpService.get(
      `page/${pageId}/subscription/status`
    );
    return response.data.data;
  },
};

const mutations = {
  SET_PAGES: (state, pages) => {
    const pagesPagination = new Pagination(pages, "pages/getAll");
    pagesPagination.result = pagesPagination.result.map(
      (_page) => new Page(_page)
    );
    state.list = pagesPagination;
  },
  SET_DCC_LIST: (state, dccList) => {
    const dccListPagination = new Pagination(dccList, "pages/getAllDCC");
    dccListPagination.result = dccListPagination.result.map(
      (_page) => new DCC(_page)
    );
    state.dccList = dccListPagination;
  },
  SET_LCC_LIST: (state, lccList) => {
    const lccListPagination = new Pagination(lccList, "pages/getAllLCC");
    lccListPagination.result = lccListPagination.result.map(
      (_page) => new LCC(_page)
    );
    state.lccList = lccListPagination;
  },
  CLEAR: (state) => {
    state.list = Pagination.prototype.createEmpty();
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
